export default __webpack_public_path__ + "static/media/right arrow_blue.05d17223.svg";